module.exports = __webpack_public_path__ + "img/logo.80c6e88e.png";